// src/features/auth/routes.js
export default [
  {
    path: 'login',
    name: 'login',
    component: () => import('./views/LoginView.vue'),
    meta: { 
      requiresGuest: true,
      title: 'Iniciar Sesión' 
    },
  },
]